import React from 'react';

import {Link} from "react-router-dom";

import {IconBook} from "../svg";

import {Colors} from "../../constants";

import "./HusnBook.scss";

const HusnBook = ({book, index}) => {

    return (
        <div className="col-sm-6 col-md-4">
            <div className="hidith-book d-flex align-items-center">
                <Link to={`/husn/${book.ID}`}>
                    <div className="info">
                        <h6 className="name">
                            {book.TITLE}
                        </h6>
                        <div className="available d-flex align-items-center">
                            <h6 className="av-text">{book.TITLE}</h6>
                            {/* <span className="av-num">{book.REPEAT}</span> */}
                        </div>
                    </div>

                    <IconBook style={{width: "1.2rem", height: "auto", fill: Colors.mainColor, opacity: .7}}/>
                    <span className="index">{index + 1}</span>
                </Link>
            </div>
        </div>
    );

}

export default HusnBook;